import {
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUEST_TYPE,
    SET_TRANSFER_ORDER_DETAILS,
    SET_TRANSFER_ORDER_NUMBER,
    ORDER_CREATION_SUCCESS,
    SET_IS_EDIT_ORDER,
    SET_IDISPOSITION,
    SET_TRANSFER_REQUEST_DATA,
    SET_ASSET_DATA,
    SET_REACTIVATION_REQUEST_DATA,
    SET_CART_IDISPOSITION,
    SET_ASSET_CART_DATA,
    SET_IS_RESET_CLICKED,
    SET_IS_LAST_REQUEST_DELETED,
    SET_IS_CART_NOT_UPDATED,
    SET_ALL_CART_ASSET,
    SET_IS_SAVE_AS_DRAFT,
    SET_IS_CHANGES_OCCURED_IN_CART,
    SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT,
    SET_AFE_RECLASSIFICATION_DATA,
    SET_LEADR_ORDER_VALIDATION,
    SET_AFE_ASSET_DETAIL_DATA,
    SET_AFE_BRANCH_ADDRESS_DETAIL,
    SET_VALIDATE_AFE_ASSET_NUMBER,
    SET_SAVE_AFE_RECLASSIFICATION,
    SET_AFE_ORDER_BY_ID,
    SET_VALIDATE_ASSETS_ON_SAVE
} from './TransferType';

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_SELECTED_BRANCH:
            return {
                ...state,
                selectedBranch: action.selectedBranch,
            };
        case SET_SELECTED_REQUEST_TYPE:
            return {
                ...state,
                selectedRequestType: action.selectedRequestType,
            };
        case SET_TRANSFER_ORDER_DETAILS:
            return {
                ...state,
                orderDetails: action.order
            }
        case SET_TRANSFER_ORDER_NUMBER:
            return {
                ...state,
                transferOrderNumber: action.number
            }
        case ORDER_CREATION_SUCCESS:
            return {
                ...state,
                orderSuccess: action.flag
            }
        case SET_IS_EDIT_ORDER:
            return {
                ...state,
                isEditOrder: action.flag
            }
        case SET_IDISPOSITION:
            return {
                ...state,
                dispositionList: action.dispositionData
            }
        case SET_CART_IDISPOSITION:
            return {
                ...state,
                dispositionCartList: action.dispositionData
            }
        case SET_TRANSFER_REQUEST_DATA:
            return {
                ...state,
                transferRequests: action.requests
            }
        case SET_ASSET_DATA:
            return {
                ...state,
                assets: action.assets
            }
        case SET_ASSET_CART_DATA:
            return {
                ...state,
                cartAssets: action.assets
            }
        case SET_REACTIVATION_REQUEST_DATA:
            return {
                ...state,
                reactivationRequests: action.requests
            }
        case SET_IS_RESET_CLICKED:
            return {
                ...state,
                isResetClicked: action.flag
            }
        case SET_IS_LAST_REQUEST_DELETED:
            return {
                ...state,
                isLastRequestDeleted: action.flag
            }
        case SET_IS_CART_NOT_UPDATED:
            return {
                ...state,
                isCartNotUpdated: action.flag
            }
            case SET_ALL_CART_ASSET:
            return {
                ...state,
                allCartAsset: action.allCartAsset
            }
            case SET_IS_SAVE_AS_DRAFT:
                return{
                    ...state,
                    isSaveAsDraft : action.isSaveAsDraft
                }
            case SET_IS_CHANGES_OCCURED_IN_CART:
                return{
                    ...state,
                    isChangesOccuredInCart : action.isChangesOccuredInCart
                }
            case SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT:
                return{
                    ...state,
                    isCostCenterAvailableForSubmit : action.isCostCenterAvailableForSubmit
                }
            case SET_AFE_RECLASSIFICATION_DATA:
                return{
                    ...state,
                    afeReClassificationData : action.afeReClassificationData
                }
            case SET_LEADR_ORDER_VALIDATION:
                return{
                    ...state,
                    leadrOrderValidation : action.leadrOrderValidation
                }
            case SET_AFE_ASSET_DETAIL_DATA:
                return{
                    ...state,
                    afeAssetDetailData : action.afeAssetDetailData
                }
            case SET_AFE_BRANCH_ADDRESS_DETAIL:
                return{
                    ...state,
                    afeBranchAddressDetail : action.afeBranchAddressDetail
                }
            case SET_VALIDATE_AFE_ASSET_NUMBER:
                return{
                    ...state,
                    afeAssetValidation : action.afeAssetValidation
                }
            case SET_SAVE_AFE_RECLASSIFICATION:
                return{
                    ...state,
                    saveAfeReclassification : action.saveAfeReclassification
                }
            case SET_AFE_ORDER_BY_ID:
                return{
                    ...state,
                    afeOrderByIdData : action.afeOrderByIdData
                }
            case SET_VALIDATE_ASSETS_ON_SAVE:
                return{
                    ...state,
                    validateAssetsOnSaveResult: action.validateAssetsOnSaveResult
                }
        default:
            return state;
    }
}

export {
    reducers
}
